import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { getCountryByCode, isValidCountryCode } from "@/data/countryData";
import { useGeoData } from "@/hooks/useGeoData";

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const { country } = useParams();
  const raw = country?.toLowerCase() || "in";
  const countryCode = isValidCountryCode(raw) ? raw : "in";
  const countryInfo = getCountryByCode(countryCode);
  const { cityData, industryData, loading: dataLoading } = useGeoData(countryCode);

  return (
    <CountryContext.Provider value={{ ...countryInfo, countryCode, cityData, industryData, dataLoading }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const ctx = useContext(CountryContext);
  if (!ctx) {
    const info = getCountryByCode("in");
    return { ...info, countryCode: "in", cityData: [], industryData: [], dataLoading: true };
  }
  return ctx;
}
